export var OrderSettings;
(function (OrderSettings) {
    OrderSettings[OrderSettings["default"] = 0] = "default";
    OrderSettings[OrderSettings["priceAscending"] = 1] = "priceAscending";
    OrderSettings[OrderSettings["priceDescending"] = 2] = "priceDescending";
    OrderSettings[OrderSettings["dataVolumeAscending"] = 3] = "dataVolumeAscending";
    OrderSettings[OrderSettings["dataVolumeDescending"] = 4] = "dataVolumeDescending";
})(OrderSettings || (OrderSettings = {}));
